export enum StepsNavigationStatus {
  COMPLETED = 'completed',
  SKIPPED = 'skipped',
}
